import React from 'react';
import { connect } from 'react-redux';
import { Link, RouteComponentProps, withRouter } from 'react-router-dom';

import Tabs, { Tab, TabContent, TabName } from '@components/Tabs';

import { fetchAgencySettings } from '@actions/agency';

import AgencySettings from './tabs/AgencySettings';
import CitizenAuthentication from './tabs/CitizenAuth';
import ProductConfiguration from './tabs/ProductConfiguration';

import './style.scss';

enum ActiveTab {
  INFO_AND_SETTINGS,
  PRODUCT_CONFIGURATIONS,
  CRM_CITIZEN_AUTH,
}

export interface IEditAgencyProps extends RouteComponentProps<{ agency: string }> {
  agency: IAgencySettings;
  agencyName: string;
  fetchAgencySettings: TFetchAgencySettings;
  isFetchingSetting: boolean;
}

export interface IEditAgencyState {
  activeTab: ActiveTab;
  agencyId: number;
}

export class EditAgency extends React.Component<IEditAgencyProps, IEditAgencyState> {
  constructor(props: IEditAgencyProps) {
    super(props);

    this.state = {
      activeTab: ActiveTab.INFO_AND_SETTINGS,
      agencyId: null,
    };
  }

  async componentDidMount() {
    const {
      params: { agency },
    } = this.props.match;

    const agencyId = +agency;

    if (agencyId) {
      // await this.props.fetchAgency(agencyId);
      await this.props.fetchAgencySettings(agencyId);
    }

    this.setState({
      agencyId,
    });
  }

  renderHeader = () => (
    <header className="edit-agency-view__header">
      <h5>
        <Link to={'/agencies'}>
          <span className={'back-arrow'} />
          Back to Agencies
        </Link>
      </h5>
      <h3>
        {this.props.agencyName} ({this.state.agencyId})
      </h3>
    </header>
  );

  renderContainer = () => (
    <>
      <main className="edit-agency-view__container">
        <Tabs activeTab={this.state.activeTab}>
          <Tab>
            <TabName>Info & Settings</TabName>
            <TabContent>
              <AgencySettings />
            </TabContent>
          </Tab>
          <Tab>
            <TabName>Product Configuration</TabName>
            <TabContent>
              <ProductConfiguration />
            </TabContent>
          </Tab>
          <Tab>
            <TabName>CRM/Citizen Authentication</TabName>
            <TabContent>
              <CitizenAuthentication />
            </TabContent>
          </Tab>
        </Tabs>
      </main>
    </>
  );

  render() {
    return (
      <>
        {this.props.agency && !this.props.isFetchingSetting ? (
          <div className="edit-agency-view">
            {this.renderHeader()}
            {this.renderContainer()}
          </div>
        ) : null}
      </>
    );
  }
}

const mapStateToProps = (state: IReduxStore) => ({
  agency: state.agency.agencySettings,
  isFetchingSetting: state.agency.isFetching,
  agencyName: state.agency.agencySettings?.name || '',
});

const mapDispatchToProps = (dispatch: any) => ({
  fetchAgencySettings: (agencyId: number) => dispatch(fetchAgencySettings(agencyId)),
  // fetchAgency: (agencyId: number) => dispatch(fetchAgency(agencyId)),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(EditAgency));
